(() => {
  const root = window.Shopify?.routes?.root || '/';

  async function addReturnLink() {
    if (!/\/cart(?:\/|$)/.test(window.location.pathname)) return;
    if (document.querySelector('.helix-cart-return')) return;
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const item = cart.items?.find((entry) => entry.properties?.['_Helix-Konfigurator-URL']);
      const url = item?.properties?.['_Helix-Konfigurator-URL'];
      if (!url) return;
      const link = document.createElement('a');
      link.className = 'helix-cart-return';
      link.href = url;
      link.textContent = '← Konfiguration bearbeiten';
      const target = document.querySelector('form[action*="/cart"] .cart__footer, form[action*="/cart"], cart-items');
      target?.prepend(link);
    } catch (error) {
      console.warn('HELIX-Rücksprung konnte nicht ergänzt werden.', error);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addReturnLink);
  else addReturnLink();
})();
